import React, { useContext, useState } from "react";
import { AuthFetch } from "../../../services/api";
import { notify, urlApiTMAN } from "../../../utils/utils";
import { UserContext } from "../../../context/provider/UserProvider";

const urlBaseNeumaticos = process.env.REACT_APP_TMAN_API + '/Tire'
const urlBaseRepuestos = process.env.REACT_APP_TMAN_API + '/Store/Replacement'
const urlBaseAlmacen = process.env.REACT_APP_TMAN_API + '/Store'

export const useNeumaticos = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa
    const codUsuario = stateUser.codUsuario

    const neumaticoDefault = {
        codEmpresa: codEmpresa,
        codAlmacenRepuestoSerie: 0,
        codNeumaticoMedida: 0,
        codNeumaticoMarca: 1,       // POR DEFECTO SE ESTA MANDANDO MICHELLIN, CUANDO SE TENGA CRUD DE MARCAS CAMBIAR A 0
        codUsuarioAccion: stateUser.codUsuario,
        medidaInterna: 0,
        medidaMedia: 0,
        medidaExterna: 0,
        presion: 0,
        profundidad: 0,
        codNeumaticoEstado: 0,
        codNeumatico: 0,
        codigoNeumatico: '',
        fechaRegistroActualizacion: '',
        codOrdenTrabajo: 0
    }
    
    const [neumatico,setNeumatico] = useState(neumaticoDefault)
    const [neumaticos,setNeumaticos] = useState([])
    const [estados,setEstados] = useState([])
    const [medidas,setMedidas] = useState([])
    const [marcas,setMarcas] = useState([])
    const [repuestosCodigos,setRepuestosCodigos] = useState([])
    const [seriesNeumaticosConMedida,setSeriesNeumaticosConMedida] = useState([])
    const [listadoNeumaticosMantenimiento, setListadoNeumaticosMantenimiento] = useState([])
    
    const listarNeumaticos = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumaticos + '?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUsuario: stateUser.codUsuario
            })
        })
        if(response.isValid){
            setNeumaticos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarEditarNeumatico = async () => {
        const esGuardar = neumatico.codNeumatico === 0
        const {codNeumatico,codigoNeumatico,fechaRegistroActualizacion,codOrdenTrabajo,...jsonGuardar} = neumatico
        const response = await AuthFetch({
            url: urlBaseNeumaticos,
            method: esGuardar ? 'POST' : 'PUT',
            body: JSON.stringify(esGuardar ? jsonGuardar : neumatico)
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const editarNeumaticoSinOT = async () => {
        const errores = []
        neumatico.codNeumaticoEstado == 0 && errores.push('Neumático estado')
        neumatico.codNeumaticoMedida == 0 && errores.push('Neumático medida')
        neumatico.medidaInterna == 0 && errores.push('Medida interna')
        neumatico.medidaMedia == 0 && errores.push('Medida media')
        neumatico.medidaExterna == 0 && errores.push('Medida externa')
        neumatico.presion == 0 && errores.push('Presión')
        neumatico.profundidad == 0 && errores.push('Profundidad')

        if(errores.length != 0){
            notify(`Campos faltantes: ${errores.join(', ')}`,'info')
            return
        }

        const response = await AuthFetch({
            url: urlBaseNeumaticos + '/noOt',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario,
                codNeumatico: neumatico.codNeumatico,
                codNeumaticoMarca: 1,
                codNeumaticoMedida: neumatico.codNeumaticoMedida,
                codNeumaticoEstado: neumatico.codNeumaticoEstado,
                medidaInterna: neumatico.medidaInterna,
                medidaMedia: neumatico.medidaMedia,
                medidaExterna: neumatico.medidaExterna,
                presion: neumatico.presion,
                profundidad: neumatico.profundidad
            })
        })
        return({
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        })
    }

    const listarEstadosNeumaticos = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumaticos + '/states?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setEstados(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarMedidasNumaticos = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumaticos + '/Measurements?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setMedidas(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarMarcasNeumaticos = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumaticos + '/Brand?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setMarcas(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarRepuestoCodigos = async (CodRepuesto,CodAlmacen,RequiereMedida = 0) => {
        const response = await AuthFetch({
            url: urlBaseRepuestos + '/series?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                CodRepuesto: CodRepuesto,
                CodAlmacen: CodAlmacen,
                CodUsuario: stateUser.codUsuario,
                RequiereMedida: RequiereMedida                   // MANEJAR DE MANERA DINAMICA 1 O 0
            })
        })
        if(response.isValid){
            setRepuestosCodigos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarSeriesNeumaticosConMedida = async (codRepuesto) => {
        const response = await AuthFetch({
            url: urlBaseAlmacen + '/SeriesNeumaticos?' + new URLSearchParams({
                CodEmpresa: codEmpresa,
                CodUsuario: stateUser.codUsuario,
                CodRepuesto: codRepuesto
            }) 
        })
        if(response.isValid){
            setSeriesNeumaticosConMedida(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const editarValorNeumatico = (key,value) => {
        setNeumatico(valorAnterior => {
            return{
                ...valorAnterior,
                [key]: value
            }
        })
    }

    const listarNeumaticoMantenimiento = async () => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Tire/NeumaticosMantenimiento?' + new URLSearchParams({
                codUsuario: codUsuario,
                codEmpresa: codEmpresa
            }),
        })
        if(response.isValid){
            setListadoNeumaticosMantenimiento(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarReintegroNeumatico = async (codNeumatico, codNeumaticoEstado) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Tire/ReintegrarNeumaticoMantenimiento',
            method: 'POST',
            body: JSON.stringify({
                "codUsuario": codUsuario,
                "codNeumatico": codNeumatico,
                "codNeumaticoEstado": codNeumaticoEstado,
                "codEmpresa": codEmpresa
            })
        })

        return({
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        })
    }

    const eliminarNeumaticoReintegro = async (codigoNeumatico) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Tire/EliminarNeumaticoMantenimiento',
            method: 'DELETE',
            body: JSON.stringify({
                "codUsuario": codUsuario,
                "codNeumatico": codigoNeumatico,
                "codEmpresa": codEmpresa
            })
        })

        return({
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        })
    }
    
    
    
    return {
        neumaticoDefault,
        neumatico,
        setNeumatico,
        listarNeumaticos,
        neumaticos,
        registrarEditarNeumatico,
        listarEstadosNeumaticos,
        estados,
        listarMedidasNumaticos,
        medidas,
        listarMarcasNeumaticos,
        marcas,
        listarRepuestoCodigos,
        repuestosCodigos,
        editarValorNeumatico,
        listarSeriesNeumaticosConMedida,
        seriesNeumaticosConMedida,
        editarNeumaticoSinOT,
        listarNeumaticoMantenimiento,
        listadoNeumaticosMantenimiento,
        registrarReintegroNeumatico,
        eliminarNeumaticoReintegro
    }
};
